import React, { Component } from 'react';
import { Link } from "@mui/material";

import loginPageCss from "../css/loginPage.module.css";
import "../css/loginPage.css"

import JoinHeader from "../component/JoinHeader";
import Footer from "../../../component/layout/Footer";

class JoinCompleteContainer extends Component {
    render() {
        return (
            <>
                <div className="container-xxl">
                    <JoinHeader
                        joinStep={3}
                    >
                        <div className={`row align-items-center justify-content-center step-third ${loginPageCss["step-third"]}`}>
                            <div className='card card-body p-5'>
                                <div className={"text-center"}>
                                    <h1 className='fs-4 py-3 text-primary-emphasis'>회원가입이 완료되었습니다.</h1>
                                    <p className='fw-medium'>현재 시점부터 서비스 이용이 가능합니다.</p>
                                    <p className='text-danger'>
                                        첫 충전 시 무료 10,000P 지급 프로모션 진행 중!<br />
                                        지금 바로 충전하고 무료 10,000P를 받아보세요!
                                    </p>

                                    <Link href={"/account/login"}>로그인 페이지로 이동하기</Link>
                                </div>
                                <div className={`${loginPageCss["bottom-line"]}`}></div>
                            </div>
                        </div>
                    </JoinHeader>
                </div>
                <Footer />
            </>
        )
    }
}

export default JoinCompleteContainer;
